module.exports = require('./base')(require('bluebird'))